function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.845 0L48.5 5.5l-13.192 8.424-.62-5.882c-12.864 2.425-21.444 7.425-25.815 14.96-5.765 9.937-7.442 20.942-5.028 33.06l.134.65.206.978-1.957.413-.207-.979c-2.706-12.849-1-24.574 5.122-35.126C11.863 13.863 21 8.558 34.48 6.046L33.845 0z",
  fill: "#FF9D49"
});

var SvgTopArrow = function SvgTopArrow(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 49 59"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OSA1OSI+PHBhdGggZD0iTTMzLjg0NTQ3LjAwMDQ4Mkw0OC41IDUuNWwtMTMuMTkyMzMgOC40MjM5MTQ3LS42MTkxNy01Ljg4MjM4M2MtMTIuODY0NjggMi40MjUyNDg4LTIxLjQ0NDMxIDcuNDI1MjEwNi0yNS44MTU3MSAxNC45NjAyNzc3LTUuNzY1MSA5LjkzNzQwNDEtNy40NDIgMjAuOTQxNzQ5Ni01LjAyNzUyIDMzLjA1OTgxOTZsLjEzMzI2LjY1MDI0OC4yMDYwOS45Nzg1MzItMS45NTcwNi40MTIxODQtLjIwNjA5LS45Nzg1MzJDLS42ODQ3IDQ0LjI3NTA2OCAxLjAyMTMgMzIuNTQ5OTk5NSA3LjE0MjgzIDIxLjk5ODE5MDYgMTEuODYyNjEgMTMuODYyNjI4NyAyMS4wMDA4NyA4LjU1ODU2MTIgMzQuNDc5NzUgNi4wNDU4NUwzMy44NDU0Ny4wMDA0ODJ6IiBmaWxsPSIjRkY5RDQ5IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=";
export { SvgTopArrow as ReactComponent };